import React, { useState, useRef, useEffect, useContext } from 'react';
import { LangContext } from './LangProvider';
import { SUPPORTED_LANGS, LANG_DISPLAY, LANG_NAMES } from './langUtils';

const buttonStyle = {
  background: 'transparent',
  border: '1px solid rgba(255,255,255,0.3)',
  color: '#fff',
  borderRadius: 4,
  padding: '4px 8px',
  cursor: 'pointer',
  fontSize: 13,
  fontWeight: 600,
  letterSpacing: 1,
  lineHeight: 1.4,
  minWidth: 38,
  textAlign: 'center'
};

const menuStyle = {
  position: 'absolute',
  top: '100%',
  right: 0,
  margin: 0,
  padding: 0,
  listStyle: 'none',
  background: '#fff',
  borderRadius: 4,
  boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
  zIndex: 1300,
  minWidth: 140
};

const itemStyle = (code, current) => ({
  padding: '8px 16px',
  cursor: 'pointer',
  fontWeight: code === current ? 700 : 400,
  color: code === current ? '#DF7D44' : '#363636',
  borderBottom: '1px solid #eee',
  fontSize: 14
});

export default function LangSelector() {
  const { lang, setLang, loading } = useContext(LangContext);
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  const handleSelect = async (code) => {
    if (code === lang) return;
    setOpen(false);
    await setLang(code);
    window.location.reload();
  };

  return (
    <div ref={ref} style={{ position: 'relative', display: 'inline-block' }}>
      <button
        onClick={() => setOpen(!open)}
        disabled={loading}
        style={buttonStyle}
      >
        {loading ? '...' : LANG_DISPLAY[lang]}
      </button>
      {open && (
        <ul style={menuStyle}>
          {SUPPORTED_LANGS.map(code => (
            <li
              key={code}
              onClick={() => handleSelect(code)}
              style={itemStyle(code, lang)}
              onMouseEnter={e => { e.target.style.background = '#f5f5f5'; }}
              onMouseLeave={e => { e.target.style.background = '#fff'; }}
            >
              {LANG_DISPLAY[code]} &mdash; {LANG_NAMES[code]}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
